// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"0f185ab1","75":"07c2545e","245":"96a9fb66","527":"07c2545e","532":"138bbffe"}[chunkId] + ".chunk.css";
};